<template>
  <artmisads-modal
    :title="
      configs.activeTab == '0'
        ? configs.modalType == 'active'
          ? $t('seller.brandsPage.modalDeactivateAttribution')
          : $t('seller.brandsPage.modalActivateAttribution')
        : configs.modalType == 'active'
        ? $t('seller.brandsPage.modalDeactivateAssociate')
        : $t('seller.brandsPage.modalActivateAssociate')
    "
    v-model:open="configs.open"
    @ok="onOk"
    @cancel="onModalCancel"
    style="width: 720px"
    :footer="null"
  >
    <div class="content">
      <img class="imgStyle" src="@/assets/images/successfulPop.png" alt="" />
      <div class="title">{{ $t('seller.brandsPage.setupSuccessful') }}</div>
      <div class="article" v-if="configs.modalType == 'active'">
        {{
          $t('seller.brandsPage.successfulDeactivatedOn', {
            name: item.amazonBrandName,
            time,
          })
        }}
      </div>
      <div class="article" v-else>
        <p>
          {{
            $t('seller.brandsPage.successfulActivatedOn', {
              name: item.amazonBrandName,
              time,
            })
          }}
        </p>
        <p>
          {{ $t('seller.brandsPage.successfulProceedPartnership') }}
        </p>
      </div>
      <artmisads-button
        v-if="configs.activeTab == '0'"
        class="btn"
        type="primary"
        @click="onOk"
        >{{ $t('seller.brandsPage.okShort') }}</artmisads-button
      >
      <artmisads-button
        v-if="configs.activeTab == '1'"
        class="btn"
        type="primary"
        @click="setUpAssociateCommission"
      >
        {{
          configs.modalType == 'active'
            ? $t('seller.brandsPage.okShort')
            : $t('seller.brandsPage.setUpAssociateCommissionNow')
        }}
      </artmisads-button>
      <div class="bottom-text" v-if="configs.modalType != 'active'">
        <p style="margin-bottom: 8px">
          {{ $t('seller.brandsPage.successfulPreferLater') }}
          <span class="bold" @click="goToAssociateBrands">{{
            $t('seller.brandsPage.pathAssociateBrands')
          }}</span>
        </p>
        <p>
          {{ $t('seller.brandsPage.successfulOrPublishers') }}
          <span class="bold" @click="goToAssociatePublishers">{{
            $t('seller.brandsPage.pathAssociatePublishers')
          }}</span>
        </p>
      </div>
    </div>
  </artmisads-modal>
</template>
<script setup name="successfulPop">
import { ref, reactive, toRefs, computed, watch, watchEffect } from 'vue'
import Icon from '@/components/Icon.vue'
import moment from 'moment'
import 'moment/locale/zh-cn'
import { useI18n } from 'vue-i18n'
import { useUserInfoStore } from '@/storeData'
import { COUNTRY_TIME_TZ } from '~/contants/common.js'

const user = useUserInfoStore()
const { locale } = useI18n()
const timezone = COUNTRY_TIME_TZ[user.userInfo.countryCode]
const emit = defineEmits(['ok', 'setUpAssociateCommission'])
const { configs, item, successInfo } = defineProps({
  configs: {
    type: Object,
    default: () => {},
  },
  item: {
    type: Object,
    default: () => {},
  },
  successInfo: {
    type: Object,
    default: () => {},
  },
})
const time = ref('')
watch(
  () => successInfo,
  (newVal, oldVal) => {
    if (newVal) {
      const momentLocale = locale.value === 'zh-CN' ? 'zh-cn' : 'en'
      time.value = moment(newVal?.effectiveTime)
        .locale(momentLocale)
        .tz(timezone)
        .format('LL')
    }
  },
  { deep: true },
)
const setUpAssociateCommission = () => {
  emit('setUpAssociateCommission')
}
const goToAssociateBrands = () => {
  window.open('/seller/associateCentral/brands', '_blank')
}
const goToAssociatePublishers = () => {
  window.open('/seller/associateCentral/publishers', '_blank')
}
const onOk = () => {
  emit('ok')
}
</script>
<style scoped lang="less">
.bottom-text {
  font-family: Sora;
  font-weight: 400;
  font-style: Regular;
  font-size: 12px;
  text-align: center;
  color: rgba(15, 6, 41, 0.7);
  .bold {
    font-family: Sora;
    font-weight: 400;
    font-style: Regular;
    font-size: 12px;
    text-decoration: underline;
    color: rgba(131, 92, 242, 1);
    cursor: pointer;
  }
}
.content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.title {
  font-family: Sora;
  font-weight: 600;
  font-style: SemiBold;
  font-size: 20px;
  color: rgba(15, 6, 41, 1);
  text-align: center;
}

.article {
  font-family: Sora;
  font-weight: 500;
  font-style: Medium;
  font-size: 14px;
  color: rgba(15, 6, 41, 0.9);
  line-height: 24px;
  letter-spacing: 0%;
  text-align: center;
  margin: 12px 0;
}

.imgStyle {
  width: 216px;
  height: 194px;
}

.btn {
  margin-bottom: 40px;
}
</style>
